export default __webpack_public_path__ + "static/footer-bg-f0cca88c73ba80ecfea11ab90bee249c.jpg";